import Image from 'next/image';
import Link from 'next/link';

import { NATIVE_TOKEN_ADDRESS_PER_CHAIN_ID } from '@/constants/addresses';
import { CHAIN_IDS, SUPPORTED_CHAIN_IDS } from '@/constants/chain';

import { tradeRoute } from '@/utils/url';

import { useMatchaWallets } from '../../../hooks/useMatchaWallets';
import { buttons } from '../../../styles/buttons';
import { fontStyles } from '../../../styles/typography';
import { getConnectedChain } from '../../../utils/wallet';

export function SwapTokensHero() {
  const { ethereumWallet } = useMatchaWallets();
  const chainId = getConnectedChain(ethereumWallet)?.id ?? CHAIN_IDS.MAINNET;

  return (
    <>
      <header
        className="mb-[96px] tablet:mb-[150px] desktop:mb-[110px] pb-[68px] tablet:pb-[30px] grid relative tablet:h-[382px] tablet:bg-[url('/images/swap-tokens/swap-tokens-hero-tablet.png')] tablet:bg-no-repeat tablet:bg-center tablet:bg-contain desktop:bg-[url('/images/swap-tokens/swap-tokens-hero.png')] desktop:bg-[length:auto_380px]"
        style={{
          marginTop: '152px',
        }}
      >
        <div
          className="pt-[96px] pb-2 tablet:pb-[84px] mx-auto tablet:mx-[104px] z-10 px-10 tablet:px-[84px] desktop:max-w-[992px] desktop:w-full desktop:mx-auto"
          style={{
            background:
              'radial-gradient(50.13% 42.41% at 50% 52.44%, #FFF 0%, #FFF 29.69%, rgba(255, 255, 255, 0.64) 62.5%, rgba(255, 255, 255, 0.00) 100%)',
          }}
        >
          <h4
            className={fontStyles({ variant: 'H2', class: 'text-center' })}
            style={{
              WebkitTextFillColor: 'transparent',
              background:
                'linear-gradient(rgba(2, 168, 99, 1), rgba(2, 168, 99, 0.49)), linear-gradient(rgba(118, 182, 36, 1), rgba(36, 182, 77, 0))',
              backgroundClip: 'text',
              fontWeight: '700',
              fontSize: '1.25rem',
              lineHeight: '3.5rem',
            }}
          >
            Search, trade, done
          </h4>
          <h1
            className={fontStyles({
              variant: 'H1',
              class:
                'text-center grid mb-6 text-[2.875rem] leading-12 tablet:text-[4rem] tablet:leading-19.5',
            })}
          >
            Swap Tokens
          </h1>
          <p
            className={fontStyles({
              variant: 'BODY_LG',
              class: 'text-token-gray-800 text-center grid mb-12 mx-auto max-w-[460px]',
            })}
          >
            Zero fee trades on 9+ million tokens across {SUPPORTED_CHAIN_IDS.length} chains. Get the
            best prices by tapping into 130+ liquidity sources.
          </p>
          <div className="grid justify-center items-center">
            <Link
              href={tradeRoute({
                address: NATIVE_TOKEN_ADDRESS_PER_CHAIN_ID[chainId],
                chainId,
              })}
            >
              <div
                className={buttons({
                  size: 'medium',
                  color: 'black',
                  class: ['px-4', 'rounded-2xl'],
                })}
                style={{
                  boxShadow:
                    '0px -1px 1px 0px rgba(0, 0, 0, 0.04) inset, 0px 1px 3px 0px rgba(0, 0, 0, 0.20)',
                }}
              >
                Start trading
              </div>
            </Link>
          </div>
        </div>
        <Image
          src="/images/swap-tokens/swap-tokens-hero-mobile.png"
          width={559}
          height={246}
          alt=""
          className="block tablet:hidden w-full h-auto"
        />
      </header>
    </>
  );
}
